// extracted by mini-css-extract-plugin
export default {"rootMenu":"DropdownMenu_rootMenu__ywcdc","menu":"DropdownMenu_menu__-NGvj"};